import { Component } from '@angular/core';
import { OkAloneService } from '../../../ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';


@Component({
  selector: 'app-passwordreset',
  templateUrl: './passwordreset.component.html',
  styleUrls: ['./passwordreset.component.scss']
})
export class PasswordresetComponent {


  passwordForm = new FormGroup ({
    password: new FormControl('',[
      Validators.required,
      Validators.minLength(6)
    ])
  });

  /* change to true when form submits to trigger the validation checks */
  submitted = false;
  /* so we don't have to type out this.loginForm.controls every time */
  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }

  token = null;


  constructor(private router: Router,public okService:OkAloneService,private route: ActivatedRoute) { }

  ngOnInit(): void {

    this.route.queryParams
      .subscribe(params => {
        //console.log(params); // { orderby: "price" }
        this.token = params['token'];
        //console.log(this.token); // price

        if(!this.token){
          this.okService.setAlert("The password reset link does not work. Please try again or contact OK Alone support.","warning");
          this.router.navigateByUrl('/login');

        }
      }
    );

  }


  submitPassword(){

    this.submitted = true;
    if (this.passwordForm.valid) {

        let values:any = this.passwordForm.value;
        values.token = this.token;
        //console.log(values);

        this.okService.post("auth/passwordreset",values)
        .subscribe({
          next: (data:any) => {
            //console.log(data);
            this.okService.setAlert("Your password has been reset, please login.","success")
            this.router.navigateByUrl('/login');
          },
          error: (e) => {
            //console.log(e);
            this.okService.setAlert(e,"warning")
          },
          complete: () => {
            //console.info('complete');
          }
      });
      }

    return false;

  }

}
